// src/dashboard/pages/teacher/Categories/components/CategoriesEmptyState.jsx

import React from "react";

export default function CategoriesEmptyState() {
  return (
    <div className="mt-5 rounded-[24px] border border-dashed border-slate-300 bg-slate-50 px-5 py-12 text-center dark:border-slate-700 dark:bg-slate-800/40">
      <div className="mx-auto h-16 w-16 rounded-full bg-gradient-to-br from-[#013E8E] via-indigo-500 to-[#4CA82F]" />

      <h3 className="mt-6 text-lg font-bold text-slate-900 dark:text-white">
        Aucun adhérent trouvé
      </h3>

      <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-slate-600 dark:text-slate-300">
        Aucun adhérent ne correspond aux filtres ou certaines données sont
        manquantes : date de naissance, genre ou poids.
      </p>
    </div>
  );
}